export default __webpack_public_path__ + "static/media/Animals-12.1f7b4abe.png";